import { useState } from 'react';

import { NewDomainModal } from '../modals';

import { Box, Button, IconButton, styled, TextField, Typography } from '@mui/material';
import { Refresh } from '@mui/icons-material';

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  background-color: #000;
  margin: 10px 0;
  padding: 5px 20px;
  border-radius: 8px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

const StyledButton = styled(Button)`
  min-width: 200px;
  font-size: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchContainer = styled(Box)`
  flex: 1;
  min-width: 200px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const BalanceText = styled(Typography)`
  white-space: nowrap;
  margin-left: auto;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const TablePanel = ({
  userName,
  serverName,
  useHook,
  handleSearch,
  balance,
  balanceCurrency,
  isLoading,
  refreshTable,
}) => {
  const [NewDomainModalOpen, setNewDomainModalOpen] = useState(false);

  return (
    <>
      <StyledBox>
        <StyledButton variant='contained' onClick={() => setNewDomainModalOpen(true)}>
          Зарегистрировать новый домен
        </StyledButton>

        <SearchContainer>
          <TextField
            fullWidth
            size='small'
            label='Поиск по доменам'
            variant='outlined'
            onChange={(e) => handleSearch(e.target.value)}
          />
        </SearchContainer>

        <BalanceText variant='subtitle1'>
          {isLoading ? 'Загрузка...' : 'Баланс: ' + balance + ' ' + balanceCurrency}
        </BalanceText>

        <IconButton onClick={refreshTable} disabled={isLoading}>
          <Refresh />
        </IconButton>
      </StyledBox>

      <NewDomainModal
        userName={userName}
        serverName={serverName}
        open={NewDomainModalOpen}
        onClose={() => setNewDomainModalOpen(false)}
        useHook={useHook}
      />
    </>
  );
};
